import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import classes from './SideBarItems.css';
import SideBarItem from './SideBarItem/SideBarItem';
import LocalizedStrings from '../../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const sideBarItems = props => {
  const { closeSideBar, match, language } = props;
  const {
    home,
    motorData,
    wireData,
    transformerData,
    more
  } = require('../../../../assets/data/LocalizedStrings/LocalizedStrings.json')[
    language
  ];

  const paths = {
    home: '/',
    motorData: '/motor-data',
    wireData: '/wire-data',
    trasformer: '/transformer-data',
    more: '/more'
  };

// Set the paragraph style to center text.
const styleit = {
    textDecoration: "none",
};

if (language === 'fr') {
    var webLink = "https://tools.se.app/index.html?lang=fr"
}
else {
    var webLink = "https://tools.se.app/index.html?lang=en"
}

  return (
    <ul className={classes.SideBarItems}>
    <a style={styleit} href={webLink}><li className={classes.SideBarItem}><h2 className={classes.SideBarItemInactive}>{home}</h2></li></a>
    <a style={styleit} href="./index.html"><li className={classes.SideBarItem}><h2 className={classes.SideBarItemInactive}>{LocalizedStrings[language].toolhome}</h2></li></a>
      
      <SideBarItem
        title={more}
        page={paths.more}
        selectedItem={match.path.substr(0, paths.more.length) === paths.more}
      />
    </ul>
  );
};

sideBarItems.propTypes = {
  language: PropTypes.string.isRequired,
  closeSideBar: PropTypes.func
};

export default withRouter(sideBarItems);
